"use client";

import React, { useState } from "react";
import { Check, Code, Copy, Globe, Search, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
export default function Seometa() {
  const [copied, setCopied] = useState(false);
  const [showDebug, setShowDebug] = useState(false);
  const seoData = {
    title: "Hochdruckreinigung & Gartenpflege in Havixbeck | Münsterland Industrieservice UG",
    description: "Umweltfreundliche Hochdruckreinigung, Steinreinigung und Gartenpflege in Havixbeck und Münsterland. Reinigung 100% ohne Chemie, nur mit Wasser.",
    canonicalUrl: "https://muensterland-industrieservice.com/",
    ogType: "website",
    ogLocale: "de_DE",
    ogSiteName: "Münsterland Industrieservice UG",
    ogImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/og_share_image.png",
    ogImageAlt: "Münsterland Industrieservice UG - Steinreinigung und Gartenpflege",
    ogImageWidth: "1200",
    ogImageHeight: "630",
    twitterCard: "summary_large_image",
    robots: "index, follow"
  };
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "HomeAndConstructionBusiness",
    "name": "Münsterland Industrieservice UG",
    "url": "https://muensterland-industrieservice.com/",
    "description": "Umweltfreundliche Hochdruck- und Steinreinigung sowie Gartenpflege in Havixbeck und dem Münsterland.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Havixbeck",
      "addressRegion": "Münsterland",
      "addressCountry": "DE"
    },
    "areaServed": "Münsterland",
    "priceRange": "$$"
  };
  const handleCopyJsonLd = () => {
    navigator.clipboard.writeText(JSON.stringify(jsonLd, null, 2));
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <section id="seometa" className="bg-background border-b border-border py-3">
      {}
      <title>{seoData.title}</title>
      <meta name="description" content={seoData.description} />
      <meta name="robots" content={seoData.robots} />
      <link rel="canonical" href={seoData.canonicalUrl} />

      {}
      <meta property="og:title" content={seoData.title} />
      <meta property="og:description" content={seoData.description} />
      <meta property="og:type" content={seoData.ogType} />
      <meta property="og:url" content={seoData.canonicalUrl} />
      <meta property="og:site_name" content={seoData.ogSiteName} />
      <meta property="og:locale" content={seoData.ogLocale} />
      <meta property="og:image" content={seoData.ogImage} />
      <meta property="og:image:width" content={seoData.ogImageWidth} />
      <meta property="og:image:height" content={seoData.ogImageHeight} />
      <meta property="og:image:alt" content={seoData.ogImageAlt} />

      {}
      <meta name="twitter:card" content={seoData.twitterCard} />
      <meta name="twitter:title" content={seoData.title} />
      <meta name="twitter:description" content={seoData.description} />
      <meta name="twitter:image" content={seoData.ogImage} />
      <meta name="twitter:image:alt" content={seoData.ogImageAlt} />

      {}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(jsonLd)
    }} />

      {}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-center justify-between gap-3 text-xs font-sans text-muted-foreground bg-muted/40 p-2.5 rounded-lg border border-border">
          <div className="flex items-center gap-2">
            <ShieldCheck className="size-4 text-primary" />
            <span className="font-semibold text-foreground">SEO Technical Metadata:</span>
            <span className="inline-flex items-center rounded-md bg-primary/10 px-2 py-0.5 text-xs font-medium text-primary">
              Active
            </span>
            <span className="hidden sm:inline text-border">|</span>
            <span className="hidden sm:inline-flex items-center gap-1">
              <Globe className="size-3" /> {seoData.ogLocale}
            </span>
          </div>

          <div className="flex items-center gap-2">
            <Button variant="outline" size="sm" onClick={() => setShowDebug(!showDebug)} className="h-7 px-2.5 text-xs">
              <Search className="size-3 mr-1" />
              {showDebug ? "Hide Tags" : "Inspect Tags"}
            </Button>

            <Button variant="ghost" size="sm" onClick={handleCopyJsonLd} className="h-7 px-2.5 text-xs">
              {copied ? <>
                  <Check className="size-3 mr-1 text-primary" />
                  Copied JSON-LD
                </> : <>
                  <Copy className="size-3 mr-1" />
                  Copy JSON-LD
                </>}
            </Button>
          </div>
        </div>

        {}
        {showDebug && <div className="mt-3 p-3 bg-muted/20 rounded-lg border border-border font-mono text-xs text-foreground space-y-2 animate-fade-in-up">
            <div className="flex items-center justify-between border-b border-border pb-2 font-sans font-medium text-muted-foreground">
              <span className="flex items-center gap-1 text-foreground">
                <Code className="size-4 text-primary" /> Rendered Head Tags
              </span>
              <span>React 19 Hoisted</span>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
              <div>
                <span className="text-primary font-semibold">Title:</span> {seoData.title}
              </div>
              <div>
                <span className="text-primary font-semibold">Canonical:</span> {seoData.canonicalUrl}
              </div>
              <div className="md:col-span-2">
                <span className="text-primary font-semibold">Description:</span> {seoData.description}
              </div>
              <div>
                <span className="text-primary font-semibold">OG Type:</span> {seoData.ogType}
              </div>
              <div>
                <span className="text-primary font-semibold">Image:</span> {seoData.ogImage}
              </div>
            </div>
          </div>}
      </div>
    </section>;
}